import { render, staticRenderFns } from "./typeFeaturedSponsorsEdition.vue?vue&type=template&id=3d85cf03"
import script from "./typeFeaturedSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./typeFeaturedSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports